<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>L’épreuve du feu</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">Par BA Tortuga</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Un Australien. Un Texan. Un bébé. Une sacrée bagarre.</p>
<p class="P_Normal">Quand sa sœur et son beau-frère meurent dans un accident, Lachlan McCoughey, propriétaire d’un ranch d’élevage bovin australien, se précipite au Texas pour sauver leur petite fille, Chloé. Il s’attend à trouver sa nièce vivant dans la misère avec les Sheffield, une ‘famille de rodéo’.</p>
<p class="P_Normal">Au lieu de cela, Lachlan tombe sur Holden Sheffield, un cowboy généreux et honnête qui gère une énorme entreprise commerciale. Ils meurent d’envie d’explorer leur attirance mutuelle, en dépit des nombreuses embûches qui encombrent leur chemin et, ensemble, ils devront trouver un moyen d’offrir à Chloé une nouvelle famille et de s’aimer, malgré des milliers d’ares et deux continents.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?3065be16